import { render, staticRenderFns } from "./wx-redirect.vue?vue&type=template&id=14b57f2a"
import script from "./wx-redirect.vue?vue&type=script&lang=js"
export * from "./wx-redirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports